import component from './Select.vue'
export default component
